import { render, staticRenderFns } from "./ProformaInvoiceAttachments.vue?vue&type=template&id=35e07c69"
import script from "./ProformaInvoiceAttachments.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports